module.exports = __webpack_public_path__ + "img/Screenshot_155 (1).d17f9d12.png";